import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { ExportPdfEvent, useAutoExportPdf } from '@/hooks/use-auto-export-pdf';
import { ExportAccountingRetrocessionFeeToPdfViewModel } from './use-export-to-pdf.viewmodel';

export type AccoutingRetrocessionFeeExportPdfEvent =
  ExportPdfEvent<'retrocession-fee'>;

export const useAutoExportAccoutingRetrocessionFeePdfViewModel = ({
  autoExport,
  pageLoaded,
  ressourceLoaded,
  exportToPdfViewModel,
  onSuccess,
  onFailed,
}: {
  autoExport: boolean;
  pageLoaded: boolean;
  ressourceLoaded: boolean;
  exportToPdfViewModel: ExportAccountingRetrocessionFeeToPdfViewModel;
  onSuccess?: () => void;
  onFailed?: () => void;
}) => {
  const { t } = useTranslation();
  useAutoExportPdf({
    source: 'retrocession-fee',
    autoExport,
    pageLoaded,
    ressourceLoaded,
    exportPdf: exportToPdfViewModel.export,
    onSuccess: () => {
      onSuccess?.();
      toast.success(t('accounting-retrocession-fee.export-pdf.success'));
    },
    onFailed: () => {
      onFailed?.();
      toast.error(t('accounting-retrocession-fee.export-pdf.failed'));
    },
  });
};
